import { useLocation, useOutlet } from 'react-router-dom'
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion'
import { cloneElement } from 'react'

interface AnimatedOutletProps {
  /**
   * 새 페이지의 진입 애니메이션이 시작될 때(= 새 서브트리가 DOM에 커밋된 직후) 호출.
   * AnimatePresence mode="wait"에서는 이 시점이 새 콘텐츠가 실제로 마운트된
   * 첫 번째 안정적인 훅 포인트이므로 스크롤 복원에 사용한다.
   */
  onPageEnter?: (pathname: string) => void
}

export function AnimatedOutlet({ onPageEnter }: AnimatedOutletProps = {}) {
  const location = useLocation()
  const outlet = useOutlet()
  const shouldReduceMotion = useReducedMotion()

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={shouldReduceMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={shouldReduceMotion ? { opacity: 0 } : { opacity: 0, y: -4 }}
        transition={
          shouldReduceMotion
            ? { duration: 0.15 }
            : { type: 'spring', stiffness: 380, damping: 30, mass: 0.8 }
        }
        onAnimationStart={() => onPageEnter?.(location.pathname)}
      >
        {outlet && cloneElement(outlet, { key: location.pathname })}
      </motion.div>
    </AnimatePresence>
  )
}
